import React, {useState} from "react";
import {apiUploadNewsImage} from "../api/news";
import {C} from "../styles";

export default function ImageUploader({value, onChange}) {
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState("");

    async function handleFileChange(e) {
        const file = e.target.files[0];
        if (!file) return;
        setUploading(true);
        setError("");
        const result = await apiUploadNewsImage(file);
        setUploading(false);
        if (result.error || !result.url) {
            setError(result.message || result.error || "Envoi impossible");
            return;
        }
        onChange({url: result.url, alt: value?.alt || ""});
    }

    return (
        <div>
            {value?.url && (
                <img src={value.url} alt={value.alt || ""} style={{maxWidth: 240, borderRadius: 8, marginBottom: 8, display: "block"}}/>
            )}
            <label style={{display: "inline-block", cursor: "pointer"}}>
                <span style={{...{border: `1px solid ${C.border}`, borderRadius: 8, padding: "8px 12px", display: "inline-block", fontSize: 13}}}>
                    {uploading ? "Envoi en cours..." : "Choisir une image"}
                </span>
                <input
                    type="file"
                    accept="image/jpeg,image/png,image/webp"
                    aria-label="Choisir une image"
                    onChange={handleFileChange}
                    disabled={uploading}
                    style={{position: "absolute", width: 1, height: 1, opacity: 0, overflow: "hidden"}}
                />
            </label>
            {error && <p style={{color: C.danger, fontSize: 12, marginTop: 6}}>{error}</p>}
        </div>
    );
}
